




















import { Event, EventJson } from '@ssp/inscreva-sse-models';
import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/base/Loading.vue';
import EventForm from '@/components/EventForm.vue';
import EventResponse from '@/components/EventResponse.vue';
import { eventStore } from '@/store/event';
import { sessionStore } from '@/store/session';

import toast from '../components/toast';
import { ToastType } from '../components/toast/tost-type.enum';

@Component({
  components: {
    Loading,
    EventForm,
    EventResponse,
  },
})
export default class EventPage extends Vue {
  private isLoading: boolean = true;

  private event: Event & { creator?: any } = null;

  private response: Event = null;

  async created() {
    const { id } = this.$route.params;
    try {
      this.event =
        (id &&
          EventJson.fromJson(
            id === sessionStore.session.event?._id ? sessionStore.session.event : await eventStore.findById(id),
          )) ||
        new Event();
    } catch (err) {
      toast('Houve um erro ao processar o evento', ToastType.ERROR);
    }
    this.isLoading = false;
  }

  private updateEvent(event: Event): void {
    this.event = event;
  }

  private goBack() {
    this.$router.go(-1);
  }

  get is_creating_event(): boolean {
    return !this.event?._id;
  }

  submit() {
    this.isLoading = true;
    this.event.idCompany = sessionStore.session.company.publicKey;
    const { name, email, id, publicKey } = sessionStore.session.user;
    if (this.is_creating_event) {
      this.event.creator = { name, email, id, publicKey };
    }
    const indexConfirmation = this.event.steps.findIndex(({ type }) => type === 'details');
    if (indexConfirmation === -1) {
      this.event.steps.push({ type: 'details', info: { identifier: 'aba_confirmacao', title: 'Confirmação' } });
    }
    return (this.is_creating_event ? eventStore.create(this.event) : eventStore.update(this.event))
      .then((response) => {
        this.response = this.is_creating_event && EventJson.fromJson(response);
        toast(`Evento ${this.is_creating_event ? 'criado' : 'modificado'} com sucesso`, ToastType.SUCESS);
        if (!this.is_creating_event) {
          this.$router.push('/events');
        }
      })
      .catch(() => toast('Evento não pode ser cadastrado', ToastType.ERROR))
      .finally(() => (this.isLoading = false));
  }
}
